import { ref, onMounted, onUnmounted } from "vue";

const DESKTOP_QUERY = "(min-width: 1024px)";

export function useBreakpoint() {
  const isDesktop = ref(
    typeof window !== "undefined"
      ? window.matchMedia(DESKTOP_QUERY).matches
      : false,
  );

  let mediaQuery: MediaQueryList | null = null;

  const handleChange = (e: MediaQueryListEvent) => {
    isDesktop.value = e.matches;
  };

  onMounted(() => {
    mediaQuery = window.matchMedia(DESKTOP_QUERY);
    isDesktop.value = mediaQuery.matches;
    mediaQuery.addEventListener("change", handleChange);
  });

  onUnmounted(() => {
    mediaQuery?.removeEventListener("change", handleChange);
  });

  return { isDesktop };
}
